import { render, staticRenderFns } from "./UserTrendFilterFormContainer.vue?vue&type=template&id=656e7f75&scoped=true"
import script from "./UserTrendFilterFormContainer.vue?vue&type=script&lang=ts"
export * from "./UserTrendFilterFormContainer.vue?vue&type=script&lang=ts"
import style0 from "./UserTrendFilterFormContainer.vue?vue&type=style&index=0&id=656e7f75&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "656e7f75",
  null
  
)

/* custom blocks */
import block0 from "@/i18n/components/user-trend/form/user-trend-filter-form-container.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fusergram-front%2Fsrc%2Fcomponents%2Fuser-trend%2Fform%2FUserTrendFilterFormContainer.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports